/** Display {@code act_contract_service.client_rate} as USD (e.g. $1,234.56). */
export function formatContractRateDisplay(clientRate) {
  if (clientRate == null || clientRate === "") {
    return "";
  }
  const normalized = String(clientRate).replace(/[$,]/g, "").trim();
  const n = Number(normalized);
  if (!Number.isFinite(n)) {
    return String(clientRate).trim();
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
}
